// src/com/auto_plan_upload/AutoPlanUploadExcel.js
import Excel from 'exceljs';

const ColumnLetters = [
    'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J',
    'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T',
    'U', 'V', 'W', 'X', 'Y', 'Z',
    'AA', 'AB', 'AC', 'AD', 'AE', 'AF' // 혹시 몰라서...
];

// const HoriCenter = { horizontal: 'center' };
const CenterMiddle = { horizontal: 'center', vertical: 'middle' };
const LeftMiddle = { horizontal: 'left', vertical: 'middle' };
const RightMiddle = { horizontal: 'right', vertical: 'middle' };
const FontRed = { color: { argb: 'FF0000' } };
const FontBlue = { color: { argb: '0000FF' } };
const FontWhite = { color: { argb: 'FFFFFFFF' } };

const MainHeaderStyle = {
    color:'FF000000',bgColor:'FFFFC877'
};
const HochaHYeaderStyle = {
    color:'FFFFFFFF',bgColor:'000000FF'
};
const TsrPrintedBgcolor = 'FFDDDDDD';
const NextDayBgcolor = 'FFFFCCAA';
const NoVehBgcolor = 'FFFF0000';

const HochaBorder = {
    top: {style:'thin', color: {argb:'FFAAAAAA'}},
    left: {style:'thin', color: {argb:'FFAAAAAA'}},
    bottom: {style:'thin', color: {argb:'FFAAAAAA'}},
    right: {style:'thin', color: {argb:'FFAAAAAA'}}
};
  

const Columns = [
    {id:'dockNo', label:'DockNo.', width: 8, style:MainHeaderStyle,}, // A
    {id:'storeName', label:'점포', width: 10, style:MainHeaderStyle}, // B
    {id:'mainVehTypeName', label:'주력/최대', width: 9, style:MainHeaderStyle}, // C
    {id:'distanceOne', label:'거리/시간', width: 10, style:MainHeaderStyle}, // D
    {id:'leftOver', label:'LO', width: 6, style:MainHeaderStyle}, // E
    {id:'totVol', label:'Total', width: 8, style:MainHeaderStyle}, // F
    {id:'nBulkPt', label:'N/Y/O', width: 8, style:MainHeaderStyle}, // G
    {id:'dayPt04', label:'당일예상PT', width: 10, style:MainHeaderStyle}, // H
    {id:'didaNote', label:'DIDA구분', width: 10, style:MainHeaderStyle}, // I
    {id:'bindOne', label:'MDD', width: 7, style:MainHeaderStyle}, // J
    {id:'bindTwo', label:'MDD2', width: 7, style:MainHeaderStyle}, // K
    {id:'balance', label:'Balance', width: 12, style:MainHeaderStyle}, // L
    {id:'hocha', label:'호차', width: 6, style:MainHeaderStyle}, // M
];


const hhmm = (h2m2) => {
    if(h2m2) {
        const t = h2m2.padStart(4, '0');
        return t.substr(0,2) + ':' + t.substr(2,2);
    }
    return '';
};

export default class AutoPlanUploadExcel {
    records = [];
    workbook = null;
    worksheet = null;

    constructor(records) {
        this.records = records;
        this.workbook = new Excel.Workbook();
        this.worksheet = this.workbook.addWorksheet('autoplan');
    }

    // add header cells.
    addHeader = () => {
        Columns.forEach((c, idx) => {
            const cell = this.worksheet.getCell(`${ColumnLetters[idx]}1`);
            cell.value = c.label;
            cell.fill = {type: 'pattern', pattern:'solid', fgColor: {argb: c.style.bgColor}};
            cell.font = { color: { argb: c.style.color } };
            cell.alignment = CenterMiddle;
            this.worksheet.getColumn(ColumnLetters[idx]).width = c.width;
        });
        // 1호차..10호차
        for(let i=1; i<=10; i++) {
            const colIndex = Columns.length + i - 1;
            const cell = this.worksheet.getCell(`${ColumnLetters[colIndex]}1`);
            cell.value = i + '호차';
            cell.fill = {type: 'pattern', pattern:'solid', fgColor: {argb: HochaHYeaderStyle.bgColor}};
            cell.font = { color: { argb: HochaHYeaderStyle.color } };
            cell.alignment = CenterMiddle;
            this.worksheet.getColumn(ColumnLetters[colIndex]).width = 9;
        }
        // set the height of the first row a little larger
        this.worksheet.getRow(1).height = 24;
    };

    getPlans = (item) => {
        const ten = Array(10).fill({});
        if(item.plans) {
            item.plans.forEach((plan)=>{
                if(plan.hocha) {
                    const idx = plan.hocha-1;
                    if(idx<10) ten[idx] = plan;
                }
            })
        }
        return ten;
    };

    renderPlans = (item, rowStart) => {
        const rowEnd = rowStart + 4;
        const plans = this.getPlans(item);
        plans.forEach((plan, idx)=>{
            const colIdx = Columns.length + idx;
            if(!plan || !plan.vehTypeAlias) {
                // merge the 5 rows for this hocha and leave it empty
                this.worksheet.mergeCells(`${ColumnLetters[colIdx]}${rowStart}:${ColumnLetters[colIdx]}${rowEnd}`);
                return;
            }
            const colLetter = ColumnLetters[colIdx];

            const vehTypeAliasCell = this.worksheet.getCell(`${colLetter}${rowStart}`);
            vehTypeAliasCell.value = plan.vehTypeAlias;
            vehTypeAliasCell.alignment = CenterMiddle;
            vehTypeAliasCell.border = HochaBorder;
            if(!plan.vehPlates) {
                vehTypeAliasCell.fill = {type: 'pattern', pattern:'solid', fgColor: {argb: NoVehBgcolor}};
                vehTypeAliasCell.font = FontWhite;
            }

            if(plan.tsrPrinted)
                vehTypeAliasCell.fill = {type: 'pattern', pattern:'solid', fgColor: {argb: TsrPrintedBgcolor}};
            if(plan.shprTime) {
                const shprTimeCell = this.worksheet.getCell(`${colLetter}${rowStart+1}`);
                shprTimeCell.value = plan.shprTime.substring(0,5);
                shprTimeCell.alignment = LeftMiddle;
                if(plan.tsrPrinted)
                    shprTimeCell.fill = {type: 'pattern', pattern:'solid', fgColor: {argb: TsrPrintedBgcolor}};
                else if(!plan.vehPlates) {
                    shprTimeCell.fill = {type: 'pattern', pattern:'solid', fgColor: {argb: NoVehBgcolor}};
                    shprTimeCell.font = FontWhite;
                }

                shprTimeCell.border = HochaBorder;
            }
            if(plan.startTime) {
                const startTimeCell = this.worksheet.getCell(`${colLetter}${rowStart+2}`);
                startTimeCell.value = plan.startTime.substring(0,5);
                startTimeCell.alignment = CenterMiddle;
                startTimeCell.font = FontBlue;
                if(plan.tsrPrinted)
                    startTimeCell.fill = {type: 'pattern', pattern:'solid', fgColor: {argb: TsrPrintedBgcolor}};
                else if(plan.nextDay)
                    startTimeCell.fill = {type: 'pattern', pattern:'solid', fgColor: {argb: NextDayBgcolor}};
                startTimeCell.border = HochaBorder;
            }
            if(plan.arriveTime) {
                const arriveTimeCell = this.worksheet.getCell(`${colLetter}${rowStart+3}`);
                arriveTimeCell.value = plan.arriveTime.substring(0,5);
                arriveTimeCell.alignment = RightMiddle;
                arriveTimeCell.font = FontRed;
                if(plan.tsrPrinted) 
                    arriveTimeCell.fill = {type: 'pattern', pattern:'solid', fgColor: {argb: TsrPrintedBgcolor}};
                else if(plan.nextDay)
                    arriveTimeCell.fill = {type: 'pattern', pattern:'solid', fgColor: {argb: NextDayBgcolor}};
                arriveTimeCell.border = HochaBorder;
            }
            if(plan.returnTime) {
                const returnTimeCell = this.worksheet.getCell(`${colLetter}${rowStart+4}`);
                returnTimeCell.value = plan.returnTime.substring(0,5);
                returnTimeCell.alignment = LeftMiddle;
                if(plan.tsrPrinted) 
                    returnTimeCell.fill = {type: 'pattern', pattern:'solid', fgColor: {argb: TsrPrintedBgcolor}};
                else if(plan.nextDay)
                    returnTimeCell.fill = {type: 'pattern', pattern:'solid', fgColor: {argb: NextDayBgcolor}};
                returnTimeCell.border = HochaBorder;
            }
        });
    }
    renderRow = (item, idx) => {
        const rowStart = 2 + idx * 5; // Each item takes 5 rows.
        const rowEnd = rowStart + 4;
        // Dock no: all 5 rows
        this.worksheet.mergeCells(`A${rowStart}:A${rowEnd}`);
        const dockNoCell = this.worksheet.getCell(`A${rowStart}`);
        dockNoCell.value = item.basicDockno;
        dockNoCell.alignment = CenterMiddle;
        // 점포: 1 for code, 4 for name
        const codeCell = this.worksheet.getCell(`B${rowStart}`);
        codeCell.value = item.storeId;
        codeCell.alignment = CenterMiddle;
        this.worksheet.mergeCells(`B${rowStart + 1}:B${rowEnd}`);
        const nameCell = this.worksheet.getCell(`B${rowStart + 1}`);
        nameCell.value = item.storeName;
        nameCell.font = { bold: true };
        nameCell.alignment = CenterMiddle;
        // 주력/최대
        const firstShipTimeCell = this.worksheet.getCell(`C${rowStart}`);
        firstShipTimeCell.value = hhmm(item.firstShipTime); // bold
        firstShipTimeCell.alignment = CenterMiddle;
        const lastShipTimeCell = this.worksheet.getCell(`C${rowStart+1}`);
        lastShipTimeCell.value = hhmm(item.lastShipTime); // red
        lastShipTimeCell.font = FontRed;
        lastShipTimeCell.alignment = CenterMiddle;
        // types: {item.mainVehTypeName}/{item.maxVehTypeName}
        this.worksheet.mergeCells(`C${rowStart + 2}:C${rowEnd}`);
        const vehTypeCell = this.worksheet.getCell(`C${rowStart+2}`);
        vehTypeCell.value = item.mainVehTypeName + '/' + item.maxVehTypeName;
        vehTypeCell.alignment = CenterMiddle;
        // distanceOne
        const distanceCell = this.worksheet.getCell(`D${rowStart}`);
        distanceCell.value = item.distanceOne;
        distanceCell.alignment = CenterMiddle;
        // basicExpectRunTime
        this.worksheet.mergeCells(`D${rowStart + 1}:D${rowEnd}`);
        const basicExpectRunTimeCell = this.worksheet.getCell(`D${rowStart + 1}`);
        basicExpectRunTimeCell.value = hhmm(item.basicExpectRunTime);
        basicExpectRunTimeCell.alignment = CenterMiddle;
        // leftOver, red font
        this.worksheet.mergeCells(`E${rowStart}:E${rowEnd}`);
        const leftOverCell = this.worksheet.getCell(`E${rowStart}`);
        leftOverCell.value = item.leftOver;
        leftOverCell.font = FontRed;
        leftOverCell.alignment = CenterMiddle;
        // totVol, 5 rows
        this.worksheet.mergeCells(`F${rowStart}:F${rowEnd}`);
        const totVolCell = this.worksheet.getCell(`F${rowStart}`);
        totVolCell.value = item.totVol;
        totVolCell.alignment = CenterMiddle;
        totVolCell.numFmt = '#,##0';
        // nBulkPt, yBulkPt, oBulkPt
        const nBulkPtCell = this.worksheet.getCell(`G${rowStart+1}`);
        nBulkPtCell.value = item.nBulkPt ? item.nBulkPt : '-';
        nBulkPtCell.alignment = CenterMiddle;
        const yBulkPtCell = this.worksheet.getCell(`G${rowStart+2}`);
        yBulkPtCell.value = item.yBulkPt ? item.yBulkPt : '-';
        yBulkPtCell.alignment = CenterMiddle;
        const oBulkPtCell = this.worksheet.getCell(`G${rowStart+3}`);
        oBulkPtCell.value = item.oBulkPt ? item.oBulkPt : '-';
        oBulkPtCell.alignment = CenterMiddle;
        // 당일예상PT: dayPt04, dayPt11, dayPt15, dayPt18
        const dayPt04Cell = this.worksheet.getCell(`H${rowStart}`);
        dayPt04Cell.value = item.dayPt04;
        dayPt04Cell.alignment = CenterMiddle;
        dayPt04Cell.font = FontRed;
        const dayPt11Cell = this.worksheet.getCell(`H${rowStart+1}`);
        dayPt11Cell.value = item.dayPt11;
        dayPt11Cell.alignment = CenterMiddle;
        dayPt11Cell.font = FontRed;
        const dayPt15Cell = this.worksheet.getCell(`H${rowStart+2}`);
        dayPt15Cell.value = item.dayPt15;
        dayPt15Cell.alignment = CenterMiddle;
        dayPt15Cell.font = FontRed;
        this.worksheet.mergeCells(`H${rowStart+3}:H${rowEnd}`);
        const dayPt18Cell = this.worksheet.getCell(`H${rowStart+3}`);
        dayPt18Cell.value = item.dayPt18;
        dayPt18Cell.alignment = CenterMiddle;
        dayPt18Cell.font = FontRed;
        // didaNote
        this.worksheet.mergeCells(`I${rowStart}:I${rowEnd}`);
        const didaNoteCell = this.worksheet.getCell(`I${rowStart}`);
        didaNoteCell.value = item.didaNote;
        didaNoteCell.alignment = CenterMiddle;
        didaNoteCell.font = FontBlue;
        // BindOne
        if(item.bindOne) {
            const oneTargetStoreIdCell = this.worksheet.getCell(`J${rowStart}`);
            oneTargetStoreIdCell.value = item.bindOne.targetStoreId;
            oneTargetStoreIdCell.alignment = CenterMiddle;
            oneTargetStoreIdCell.font = FontBlue;
            const oneTargetHochaCell = this.worksheet.getCell(`J${rowStart+1}`);
            oneTargetHochaCell.value = item.bindOne.targetHocha.toString().padStart(3,'0');
            oneTargetHochaCell.alignment = CenterMiddle;
            oneTargetHochaCell.font = FontBlue;
            const oneBindStoreIdCell = this.worksheet.getCell(`J${rowStart+3}`);
            oneBindStoreIdCell.value = item.bindOne.bindStoreId;
            oneBindStoreIdCell.alignment = CenterMiddle;
            oneBindStoreIdCell.font = FontBlue;
            const oneBindHochaCell = this.worksheet.getCell(`J${rowStart+4}`);
            oneBindHochaCell.value = item.bindOne.bindHocha.toString().padStart(3,'0');
            oneBindHochaCell.alignment = CenterMiddle;
            oneBindHochaCell.font = FontBlue;
        }
        else {
            // merge the 5 rows for BindOne and leave it empty
            this.worksheet.mergeCells(`J${rowStart}:J${rowEnd}`);
        }
        // BindTwo
        if(item.bindTwo) {
            const twoTargetStoreIdCell = this.worksheet.getCell(`K${rowStart}`);
            twoTargetStoreIdCell.value = item.bindTwo.targetStoreId;
            twoTargetStoreIdCell.alignment = CenterMiddle;
            twoTargetStoreIdCell.font = FontBlue;
            const twoTargetHochaCell = this.worksheet.getCell(`K${rowStart+1}`);
            twoTargetHochaCell.value = item.bindTwo.targetHocha.toString().padStart(3,'0');
            twoTargetHochaCell.alignment = CenterMiddle;
            twoTargetHochaCell.font = FontBlue;
            const twoBindStoreIdCell = this.worksheet.getCell(`K${rowStart+3}`);
            twoBindStoreIdCell.value = item.bindTwo.bindStoreId;
            twoBindStoreIdCell.alignment = CenterMiddle;
            twoBindStoreIdCell.font = FontBlue;
            const twoBindHochaCell = this.worksheet.getCell(`K${rowStart+4}`);
            twoBindHochaCell.value = item.bindTwo.bindHocha.toString().padStart(3,'0');
            twoBindHochaCell.alignment = CenterMiddle;
            twoBindHochaCell.font = FontBlue;
        }
        else {
            // merge the 5 rows for BindTwo and leave it empty
            this.worksheet.mergeCells(`K${rowStart}:K${rowEnd}`);
        }
        // balance
        const totalPtCell = this.worksheet.getCell(`L${rowStart}`);
        totalPtCell.value = item.totalPt;
        totalPtCell.alignment = CenterMiddle;
        this.worksheet.mergeCells(`L${rowStart + 1}:L${rowStart+2}`);
        const restOverPtCell = this.worksheet.getCell(`L${rowStart + 1}`);
        restOverPtCell.value = item.restOverPt;
        restOverPtCell.alignment = CenterMiddle;
        restOverPtCell.font = FontRed;
        const nextday04PtCell = this.worksheet.getCell(`L${rowStart + 3}`);
        nextday04PtCell.value = item.nextday04Pt;
        nextday04PtCell.alignment = CenterMiddle;
        nextday04PtCell.font = FontBlue;
        const comNameCell = this.worksheet.getCell(`L${rowStart + 4}`);
        comNameCell.value = item.comName.substring(0,6);
        comNameCell.alignment = CenterMiddle;
        // Set labels in hocha column: 차종, 접안, 출발, 도착, 복귀
        const typeLabelCell = this.worksheet.getCell(`M${rowStart}`);
        typeLabelCell.value = '차종';
        typeLabelCell.alignment = CenterMiddle;
        const dockLabelCell = this.worksheet.getCell(`M${rowStart + 1}`);
        dockLabelCell.value = '접안';
        dockLabelCell.alignment = CenterMiddle;
        const startLabelCell = this.worksheet.getCell(`M${rowStart + 2}`);
        startLabelCell.value = '출발';
        startLabelCell.alignment = CenterMiddle;
        const arriveLabelCell = this.worksheet.getCell(`M${rowStart + 3}`);
        arriveLabelCell.value = '도착';
        arriveLabelCell.alignment = CenterMiddle;
        const returnLabelCell = this.worksheet.getCell(`M${rowStart + 4}`);
        returnLabelCell.value = '복귀';
        returnLabelCell.alignment = CenterMiddle;

        // Render plans
        this.renderPlans(item, rowStart);
    };

    createExcel = async () => {
        this.addHeader();
        // this.testRow({}, 0);
        this.records.forEach((item, idx) => {
            this.renderRow(item, idx);
        });

        const buf = await this.workbook.xlsx.writeBuffer();
        const blob = new Blob([buf]);
        return blob;
    };
}